import { Box, useTheme } from '@mui/material';
import React, { useMemo } from 'react';
import { getPriorityLabel } from '../../constant';

type TaskPriorityChipProps = {
    taskPriority?: number;
};

const TaskPriorityChip: React.FunctionComponent<TaskPriorityChipProps> = function ({
    taskPriority,
}) {
    const { palette } = useTheme();

    const taskPriorityColor = useMemo(() => {
        switch (taskPriority) {
            case 1:
                return palette.warning.main;
                break;
            case 2:
                return palette.error.main;
                break;

            default:
                return palette.grey[500];
                break;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [taskPriority]);

    return (
        <Box
            data-testid="task-priority-chip"
            sx={{
                padding: '4px 8px',
                borderRadius: '4px',
                backgroundColor: taskPriorityColor,
                color: palette.common.white,
            }}
        >
            {getPriorityLabel(taskPriority)}
        </Box>
    );
};

export default TaskPriorityChip;
